import { Form } from "react-bootstrap";
import CreatableSelect from 'react-select/creatable';

export interface ICountryChooserProps {
    onChange: (newVal: string) => void;
    className?: string;
    defaultValue?: string;
    multi?: boolean;
}

const countries = [
    "Argentina",
    "Australia",
    "Austria",
    "Bahrain",
    "Belarus",
    "Belgium",
    "Bolivia",
    "Bosnia-Herzegovina",
    "Brazil",
    "Burkino Faso",
    "Canada",
    "Chile",
    "Colombia",
    "Croatia",
    "Czech Republic",
    "Denmark",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Estonia",
    "Finland",
    "France",
    "Germany",
    "Greece",
    "Guatemala",
    "Hong Kong",
    "Hungary",
    "India",
    "Indonesia",
    "Iraq",
    "Israel",
    "Italy",
    "Japan",
    "Jordan",
    "Kazakhstan",
    "Kuwait",
    "Lithuania",
    "Macedonia",
    "Malaysia",
    "Mexico",
    "Mongolia",
    "Netherlands",
    "New Zealand",
    "Norway",
    "Oman",
    "Pakistan",
    "Peoples Republic Of China",
    "Peru",
    "Philippines",
    "Poland",
    "Portugal",
    "Qatar",
    "Republic Of Ireland",
    "Romania",
    "Russia",
    "Saudi Arabia",
    "Serbia",
    "Singapore",
    "Slovenia",
    "South Africa",
    "South Korea",
    "Spain",
    "Sweden",
    "Switzerland",
    "Thailand",
    "Turkey",
    "United Arab Emirates",
    "United Kingdom",
    "United States",
    "United States (export)",
    "Uruguay",
    "Venezuela",
    "Vietnam"
];

const CountryChooser = (props: ICountryChooserProps) => {
    if (props.multi) {
        return (
            <CreatableSelect
                className={`basic-multi-select ${props.className}`}
                classNamePrefix="select"
                isMulti={true}
                value={
                    props.defaultValue ?
                        props.defaultValue
                            .split(",")
                            .map((option) => ({
                                value: option,
                                label: option,
                                color: undefined,
                                isFixed: false,
                                isDisabled: false
                            })) :
                        undefined
                }
                isSearchable={true}
                isClearable={true}
                // @ts-ignore
                options={
                    (countries || [])
                        .map(
                            country => (
                                {
                                    value: country,
                                    label: country,
                                    color: undefined,
                                    isFixed: false,
                                    isDisabled: false
                                }))
                }
                onChange={(newValues) => {
                    const result =
                        [].slice.call(newValues)
                            // @ts-ignore
                            .map(o => o.value)
                            .join(",");

                    if (props.onChange) {
                        props.onChange(result);
                    }
                }} />
        );
    }
    else {
        return (
            <Form.Control
                className={`form-select ${props.className}`}
                as="select"
                value={props.defaultValue}
                onChange={
                    (e: React.ChangeEvent<HTMLInputElement>) => {
                        props.onChange(e.target.value);
                    }}>
                <option value="">Choose one</option>
                {
                    countries.map((country, index) => {
                        return (
                            <option key={index} value={country}>{country}</option>
                        );
                    })
                }
            </Form.Control>
        );
    }
}

export default CountryChooser;